module.exports = __webpack_public_path__ + "static/fonts/yousheGB.1726685.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/yousheGB.ttf
// module id = EYP4
// module chunks = 92